﻿import { CategoricalIndicatorPalette } from '@fe/weather';
import { DashedLineHorizontalOutline, LineHorizontalOutline, Plane4Outline } from '../../../../../../icons/icons';
import { UDViewPlaneModel } from '../../../../../../udView/udview';
import { DEFAULT_ROUTE_FLOWN_COLOR } from '@fe/flight-layer';

// FIXME: palette IDs should not overlap with GDF palette IDs
enum PlanePaletteId {
    Header,
    Route,
    Misc
}

export const planeHeaderPalette = (planeUdView: UDViewPlaneModel): CategoricalIndicatorPalette | null => {
    if (
        !planeUdView.settings.showActive &&
        !planeUdView.settings.showScheduled &&
        !planeUdView.settings.showPlanned &&
        (!planeUdView.filter.useFilters || planeUdView.filter.planeFilterSettings.every((f) => !f.isActive))
    ) {
        return null;
    }

    return {
        id: PlanePaletteId.Header,
        type: 'categorical',
        entries: planeUdView.filter.planeFilterSettings
            .filter((f) => !planeUdView.filter.useFilters || f.isActive)
            .map(
                (filter) =>
                    ({
                        label: filter.name,
                        color: filter.color,
                        icon: Plane4Outline,
                        hide: !planeUdView.settings.showActive
                    }) as CategoricalIndicatorPalette['entries'][0]
            )
            .concat([
                {
                    label: 'Active',
                    icon: Plane4Outline,
                    color: '#5585f5',
                    hide: !planeUdView.settings.showActive
                },
                {
                    label: 'Scheduled',
                    icon: Plane4Outline,
                    color: '#ebebc8',
                    hide: !planeUdView.settings.showScheduled
                },
                {
                    label: 'Planned',
                    icon: Plane4Outline,
                    color: '#00dc00',
                    hide: !planeUdView.settings.showPlanned
                }
            ]),
        scale: 1.2
    };
};

export const planeRoutePalette = (planeUdView: UDViewPlaneModel): CategoricalIndicatorPalette => {
    return {
        name: 'Routes',
        id: PlanePaletteId.Route,
        type: 'categorical',
        entries: [
            {
                label: 'Planned route',
                icon: LineHorizontalOutline,
                color: planeUdView.settings.flightPlanColor || '#000000'
            },
            {
                label: 'ATC route',
                icon: LineHorizontalOutline,
                color: '#00ff0080' //TODO use config
            },
            {
                label: 'Route flown',
                icon: LineHorizontalOutline,
                color: planeUdView.settings.routeFlownColor || DEFAULT_ROUTE_FLOWN_COLOR
            },
            {
                label: 'Impacts',
                color: '#ff0000' //TODO use config
            }
        ],
        scale: 1.2
    };
};

export const planeMiscPalette = (planeUdView: UDViewPlaneModel): CategoricalIndicatorPalette | null => {
    if (
        !planeUdView.settings.showHistory &&
        !planeUdView.vector.isVisible &&
        !planeUdView.range.isVisible &&
        !planeUdView.settings.showDiversionLines
    ) {
        return null;
    }

    return {
        name: 'Misc',
        id: PlanePaletteId.Misc,
        type: 'categorical',
        entries: [
            {
                label: 'Track history',
                color: planeUdView.settings.historyColor || '#000000',
                hide: !planeUdView.settings.showHistory
            },
            {
                label: 'Velocity vectors',
                icon: LineHorizontalOutline,
                color: planeUdView.vector.lineColor || '#000000',
                hide: !planeUdView.vector.isVisible
            },
            {
                label: 'Range rings',
                color: planeUdView.range.color || '#000000',
                hide: !planeUdView.range.isVisible
            },
            {
                label: 'Diversion from',
                color: '#ff0000',
                icon: DashedLineHorizontalOutline,
                hide: !planeUdView.settings.showDiversionLines
            },
            {
                label: 'Diversion to',
                color: '#00ff00',
                icon: DashedLineHorizontalOutline,
                hide: !planeUdView.settings.showDiversionLines
            }
        ],
        scale: 1.2
    };
};
